import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  aliquotRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));
